<div *ngIf="isDesktop && showSideNav" class="side-nav-holder" [ngClass]="{'collapsed' : sideNavIsCollapsed}">
  <div class="collapse-toggle noselect" [ngClass]="{'collapsed' : sideNavIsCollapsed}" (click)="onCollapsePressed()"><i
      class="material-icons">keyboard_arrow_right</i>
  </div>
  <app-panel-navigation class="noselect"></app-panel-navigation>
</div>
